module.exports = __webpack_public_path__ + "img/no_user.0bbdbbd1.png";